export default function addQueryParams(baseUrl, queryParams) {
  baseUrl += '?';
  for (let [k, v] of Object.entries(queryParams)) {
    baseUrl += `${k}=${v}&`;
  }
  return baseUrl;
}
